import hub, { E } from 'shared/utils/Hub';
import { getSelectedDataHandler } from './getSelectedData';
import { parse } from 'url';

export const onKeyDownHandler = component => {
  return e => {
    const { props, state } = component;
    const getSelectedData = getSelectedDataHandler(component);

    const { close } = props;
    let position = state.selected;
    const max = state.resultCount - 1;

    // Only deal w/ arrow up, down & enter
    if (e.keyCode === 38 || e.keyCode === 40) {
      if (e.keyCode === 38) {
        position = position > 1 ? position - 1 : 0;
      } else {
        position = position < max ? position + 1 : max;
      }
      component.setState(() => ({
        selected: position,
      }));
    } else if (e.keyCode === 13) {
      // When Enter is triggered
      e.preventDefault();
      const selected = getSelectedData();

      if (!selected) {
        return;
      }

      // don't let player play if contentType === link

      if (selected?.contentType !== 'link') {
        hub.trigger(
          E.PLAY_BUT_NOT_REALLY,
          selected.catalogType,
          selected.catalogId,
          selected.playedFrom,
          { deferAfterCardChange: true },
        );
      }

      if (!(selected.url && selected.url.substr(0, 10) === 'javascript')) {
        if (parse(selected.url).hostname) {
          window.open(selected.url, '_blank');
        } else {
          props.navigate({ path: selected.url });
        }
      }
      close();
    } else if (e.keyCode === 27) {
      component.setState({ exitType: 'escape' }, () => {
        close();
      });
    }
  };
};
